import React from 'react'
import { Link } from 'react-router-dom'

import SinglePageNavbar from '../components/single-page-navbar'
import Feature from '../components/feature'
import AboutOne from '../components/about-one'
import AboutTwo from '../components/about-two'
import Blog from '../components/blog'
import Contact from '../components/contact'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import HomeBannner from '../components/home-bannner'
import AboutThree from '../components/about-three'
import Cta from '../components/cta'
import Faq from '../components/faq'

export default function Onepage() {
  return (
    <>
    <SinglePageNavbar/>

    <HomeBannner/>

    <section className="bg-white py-5 border-top border-bottom">
        <div className="container">
            <Feature/>
        </div>
    </section>
       
    <section className="section" id="services">
        <AboutOne/>

        <div className="container mt-100 mt-60">
            <AboutTwo/>
        </div>

        <div className="container mt-100 mt-60">
            <AboutThree/>
        </div>
    </section>

    <Cta/>
    
    <section className="section" id="faqs">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6">
                    <div className="section-title mb-md-0 mb-0 ms-lg-3">
                        <span className="badge bg-primary mb-2">FAQs</span>
                        <h4 className="title mb-3 mb-md-5 pb-md-4">Got a question? <br/> Get your answer</h4>
                        <p className="text-muted para-desc mb-0 mt-md-4">Ensuring secure transactions and seamless financial experiences for our users globally.</p>
                        <div className="mt-3 d-none d-md-block">
                            <Link to="" className="btn btn-soft-primary">Contact Now <i className="mdi mdi-arrow-right"></i></Link>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6 mt-4 mt-md-0 pt-2 pt-md-0">
                    <div className="ms-lg-3">                        
                        <Faq/>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="section bg-light" id="blogs">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="section-title text-center mb-4 pb-2">
                        <h4 className="title mb-3">Blog Or News</h4>
                        <p className="text-muted para-desc mx-auto mb-0">Ensuring secure transactions and seamless financial experiences for our users globally.</p>
                    </div>
                </div>
            </div>
            <Blog/>
        </div>
    </section>

    <section className="section" id="contactus">
        <Contact/>
    </section>

    <Footer/>

    <ScrollToTop/>
    </>
  )
}
